import React from "react";
import { SourceTag } from "./SourceTag";

/**
 * Labelled numeric input. The value stays a string while it is being typed so
 * an emptied field does not snap back to 0; the calculators coerce it.
 */
export function NumberField({
  id,
  label,
  value,
  onChange,
  prefix,
  suffix,
  step = 1,
  hint,
  source,
  placeholder,
}) {
  return (
    <div className="pl-field">
      <span className="pl-field-top">
        <label className="pl-field-label" htmlFor={id}>
          {label}
        </label>
        <SourceTag source={source} />
      </span>
      <span className="pl-field-input">
        {prefix ? <span className="pl-field-affix">{prefix}</span> : null}
        <input
          id={id}
          type="number"
          inputMode="decimal"
          min={0}
          step={step}
          value={value}
          placeholder={placeholder}
          onChange={(event) => onChange(event.target.value)}
        />
        {suffix ? <span className="pl-field-affix">{suffix}</span> : null}
      </span>
      {hint ? <span className="pl-field-hint">{hint}</span> : null}
    </div>
  );
}
